import { startOfMonth } from "date-fns/startOfMonth";
import { EChartTimeseries } from "../../../../components/EChartTimeseries";
import { useTRPC } from "../../../../trpc";
import { endOfMonth } from "date-fns/endOfMonth";
import type { Tileset } from "../types/tileset";
import { Group } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useMemoizedBarSeries } from "../../../../hooks/chart.js";

export function TilesetUsageChart({ tileset, height = 240 }: { tileset: Tileset; height?: number }) {
  const trpc = useTRPC();

  const { data: usage = [] } = useQuery(trpc.getTilesetTileUsage.queryOptions({
    from: startOfMonth(new Date()),
    to: endOfMonth(new Date()),
    interval: "day",
    tilesetId: tileset.id,
  }, {
    refetchInterval: 1000 * 60 * 15,
    refetchOnMount: false,
    staleTime: 1000 * 60 * 15,
  }));

  const usageSeries = useMemoizedBarSeries(usage);

  return (
    <Group h={height}>
      <EChartTimeseries
        series={usageSeries}
        xLabel="Date"
        yLabel="Number of requests"
      />
    </Group>
  );
}
